/* eslint-disable import/no-unresolved */
import { ProfileInfoDataInterface } from "@/modules/Astro/UserProfile/ProfilesInfo/profileTypes";
import { getCategoryMeta } from "../../utils/categoryIcon";
import styles from "./Expertise.module.scss";

interface ExpertiseProps {
  userData?: ProfileInfoDataInterface;
}

export default function Expertise({ userData }: ExpertiseProps) {
  const helps = userData?.profile?.helps ?? [];

  if (!helps.length) return null;

  return (
    <section className={styles.card}>
      <div className={styles.heading}>
        <span className={styles.bar}></span>

        <h2>What they help with</h2>
      </div>

      <div className={styles.grid}>
        {helps.map((item) => {
          const { icon: Icon, color } = getCategoryMeta(item.title);

          return (
            <div className={styles.item} key={item._id}>
              <div
                className={styles.icon}
                style={{
                  color,
                  backgroundColor: `${color}15`,
                  boxShadow: `0 0 0 1.5px ${color}50`,
                }}
              >
                <Icon size={22} />
              </div>

              <div>
                <h3>{item.title}</h3>
                {item.caption && <p>{item.caption}</p>}
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
}
